import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
declare const UIkit: any;
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { SessionService } from '@app/shared/services/session.service';
import { DateService } from '@app/shared/services/date.service';
import { UsersService } from '@app/shared/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';
import { Router } from '@angular/router';
import { RestApiService } from '@app/shared/services/rest-api.service';
import { CreatedReservation, ReservationPlannerComponent } from '@app/components/reservation-planner/reservation-planner.component';
import { RESERVATION_STATUS_NAMES } from '@app/shared/constants/reservation-status';
import { environment } from '@env/environment';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, first } from "rxjs/internal/operators";

@Component({
    selector: 'app-reservation-list',
    templateUrl: './reservation-list.component.html',
    styleUrls: ['./reservation-list.component.scss']
})
export class ReservationListComponent implements OnInit {

    @ViewChild(ReservationPlannerComponent) private planner: ReservationPlannerComponent;

    /* Session */

    private sessionStatusNames = RESERVATION_STATUS_NAMES;
    public testMode = environment.testMode;

    /* Datepicker */

    public dateStart: string = moment().subtract(31, 'days').format('DD/MM/YYYY').split('T')[0];
    public dateEnd: string = moment().add(10, 'days').format('DD/MM/YYYY').split('T')[0];
    public dateStartChanged: Subject<string> = new Subject<string>();
    public dateEndChanged: Subject<string> = new Subject<string>();

    /* Filters */

    public pickerReservation: any;
    public status: number = 0;
    public search: string = '';
    public searchChanged: Subject<string> = new Subject<string>();
    public societySearch: string = '';
    // public societySelected: number = 0;
    // public societyOptions: any = [];
    // public societyDisplay: boolean = false;
    // public societyNoResult: boolean = false;
    // public societyLoading: boolean = false;
    // public _timeout: any = null;

    /* List */

    public reservations: Array<any> = [];
    public comeUp: Array<any> = [];
    public inProgress: Array<any> = [];
    public finished: Array<any> = [];
    public canceled: Array<any> = [];
    public maxPages: number = 1;
    public currentPage: number = 1;
    public loadingStatus: boolean = true;
    public noResult: boolean = false;
    public excelLoading: boolean = false;
    public selectCarSharing: boolean = false;

    /* New reservation modal */

    public showPlannerModal: boolean = false;
    public plannerSocietyCode: string = '';
    public plannerIdSocietyVop: number = 0;
    public plannerIdAccountTarget: number = 0;
    public societies: Array<any> = [];
    public newReservationError: string = '';

    /* Planner user search */

    public plannerUserSearch: string = '';
    public plannerUserOptions: any[] = [];
    public plannerShowUserOptions: boolean = false;
    public plannerSelectedUser: any = null;
    private plannerUserSearchChanged: Subject<string> = new Subject<string>();

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private reservationService: ReservationsService,
        private excelService: ExcelService,
        private route: ActivatedRoute,
        public session: SessionService,
        private dateService: DateService,
        private userService: UsersService,
        private alertService: AlertService,
        private router: Router,
        private societiesService: SocietiesService,
        private api: RestApiService,
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.search = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterSearch', model);
                this.updateReservations();
            });

        this.dateStartChanged
            .subscribe(model => {
                this.dateStart = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterDateStart', model);
                this.updateReservations();
            });

        this.dateEndChanged
            .subscribe(model => {
                this.dateEnd = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterDateEnd', model);
                this.updateReservations();
            });

        this.plannerUserSearchChanged
            .pipe(debounceTime(400))
            .subscribe(q => {
                if (q.length >= 2) {
                    this.searchPlannerUsers(q);
                } else {
                    this.plannerUserOptions = [];
                    this.plannerShowUserOptions = false;
                }
            });
    }

    retrieveFilters() {
        this.search = ('ReservationFilterSearch' in sessionStorage) ? sessionStorage.getItem('ReservationFilterSearch') : this.search;
        this.dateStart = ('ReservationFilterDateStart' in sessionStorage) ? sessionStorage.getItem('ReservationFilterDateStart') : this.dateStart;
        this.dateEnd = ('ReservationFilterDateEnd' in sessionStorage) ? sessionStorage.getItem('ReservationFilterDateEnd') : this.dateEnd;
        this.status = ('ReservationFilterStatus' in sessionStorage) ? parseInt(sessionStorage.getItem('ReservationFilterStatus'), 10) : this.status;
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.vehicule) {
                    this.search = params.vehicule;
                    sessionStorage.setItem('ReservationFilterSearch', params.vehicule);
                    this.updateReservations();
                }
            });

        this.titleService.setTitle(`Liste des réservations / VOP`);
        this.menu.setMenuState('reservation', 'reservation', '');
        this.retrieveFilters();

        if ('ReservationList' in sessionStorage
            && moment(sessionStorage.getItem('ReservationListTimeout')).isBetween(moment().subtract(2, 'minute'), moment())) {
            this.reservations = JSON.parse(sessionStorage.getItem('ReservationList'))
            this.maxPages = parseInt(sessionStorage.getItem('ReservationListMaxPages'), 10);
            this.currentPage = parseInt(sessionStorage.getItem('ReservationListCurrentPage'), 10);

            if (this.status !== 0) {
                this.sortReservationsByStatus();
            }

            this.getStaffStatus();
            this.getFinishedInvoiceFields();
            this.loadingStatus = false;
        } else {
            this.initReservations(0);
        }
    }

    getCommentTooltipTitle(reservation: any): string {
        const parts: string[] = [];
        if (reservation.Comment) {
            parts.push(reservation.Comment.replace(/\n/g, '<br>'));
        }
        if (this.testMode) {
            if (parts.length) {
                parts.push('<hr style="margin:4px 0;border-color:rgba(255,255,255,0.25)">');
            }
            const statusName = this.getStatus(reservation.Status);
            parts.push(
                '<span class="vop-testinfo-red"><strong>Test Mode Activated</strong><br>' +
                `(${reservation.Id}) statut ${reservation.Status}, ${statusName}<br>` +
                '<em>Extra technical information is displayed in test mode.</em><br>' +
                '<em>You can disable Test Mode in your environment file.</em></span>'
            );
        }
        return parts.join('<br>');
    }

    initCommentTooltip(event: MouseEvent, reservation: any): void {
        const el = event.currentTarget as any;
        if (el._commentTooltipReady) { return; }
        el._commentTooltipReady = true;
        const title = this.getCommentTooltipTitle(reservation);
        if (!title || typeof UIkit === 'undefined') { return; }
        const instance = UIkit.tooltip(el, { title, pos: 'top' });
        setTimeout(() => instance.show(), 0);
    }

    getStatus(status): string {
        let stat = status || this.status

        if (stat == 20) {
            return 'Réservation annulée'
        }
        else if (stat >= 0 && stat <= 14) {
            return this.sessionStatusNames[stat];
        }
        else {
            return 'Status Inconnu: ' + stat;
        }
    }

    changeStatus(status): void {
        this.status = status;
        sessionStorage.setItem('ReservationFilterStatus', this.status.toString());
        this.updateReservations();
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }

    onDateChange(start, date): void {
        if (start === true) {
            this.dateStartChanged.next(date);
        } else {
            this.dateEndChanged.next(date);
        }
    }

    setReservations(res): void {
        res = this.dateService.convertAlltoLocal(res);
        this.reservations = res;

        for (let i = 0; i < this.reservations.length; i++) {
            if (this.reservations[i].Status >= 3 && this.reservations[i].Status <= 10) {
                if (!this.reservations[i].ISORealDateEnd) {
                    if (new Date(this.reservations[i].ISODateEnd).getTime() < new Date().getTime()) {
                        this.reservations[i].Status = 21;
                    }
                }
                else {
                    if (new Date(this.reservations[i].ISORealDateEnd).getTime() < new Date().getTime()) {
                        this.reservations[i].Status = 21;
                    }
                }
            }
        }

        sessionStorage.setItem('ReservationList', JSON.stringify(this.reservations));
        sessionStorage.setItem('ReservationListMaxPages', this.maxPages.toString());
        sessionStorage.setItem('ReservationListCurrentPage', this.currentPage.toString());
        sessionStorage.setItem('ReservationListTimeout', moment().format());

        if (this.status !== 0) {
            this.sortReservationsByStatus();
        }
        else {
            this.comeUp = [];
            this.inProgress = [];
            this.finished = [];
            this.canceled = [];
        }

        this.getStaffStatus();
        this.getFinishedInvoiceFields();
    }

    sortReservationsByStatus(): void {
        this.comeUp = [];
        this.inProgress = [];
        this.finished = [];
        this.canceled = [];
        this.reservations.forEach((reservation) => {
            if (reservation.Status === -1) {
                this.canceled.push(reservation);
            }
            if (reservation.Status >= 0 && reservation.Status <= 2) {
                this.comeUp.push(reservation);
            }
            if (reservation.Status >= 3 && reservation.Status <= 10) {
                this.inProgress.push(reservation);
            }
            if (reservation.Status >= 11 && reservation.Status <= 14) {
                this.finished.push(reservation);
            }
        });
    }

    getFinishedInvoiceFields(): void {
        this.finished.forEach((reservation, index) => {
            this.reservationService.getReservationInvoiceFields(reservation.Id).then((res) => {
                reservation.totalAmount = 0;
                if (res && res.length > 0) {
                    res.forEach((line) => {
                        reservation.totalAmount += line.IncludingTaxes * line.Quantity;
                    });
                }
            });
        });
    }

    getStaffStatus(): void {
        [this.finished, this.comeUp, this.inProgress, this.canceled].forEach((reservationList) => {
            reservationList.forEach((reservation) => {
                reservation.loading = true;
                this.userService.getUser(reservation.IdAccount).then((user) => {
                    reservation.CodeSociety = user.CodeSociety;
                    if (user.IdAccountDemo > 0) {
                        reservation.demo = true;
                    } else {
                        reservation.demo = false;
                    }
                    reservation.loading = false;
                });
            });
        });
    }

    initReservations(next) {
        if (next === 390) {
            return;
        }

        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then((res) => {
            this.maxPages = this.reservationService.maxPages;
            if (res.length === 0) {
                this.noResult = true;
                this.dateStart = moment().subtract(next + 30, 'days').format('DD/MM/YYYY').split('T')[0];
                this.dateEnd = moment().subtract(next, 'days').format('DD/MM/YYYY').split('T')[0];
                this.initReservations(next + 30);
            } else {
                this.loadingStatus = false;
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    updateReservations() {
        this.loadingStatus = true;

        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then((res) => {
            this.maxPages = this.reservationService.maxPages;
            this.loadingStatus = false;
            if (res.length === 0) {
                this.noResult = true;
            } else {
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    nextPage() {
        if (this.currentPage < this.reservationService.maxPages) {
            this.loadingStatus = true;
            this.currentPage += 1;
            this.reservationService.updateReservationByDate(
                moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                this.currentPage, this.status, this.search, this.societySearch
            ).then((res) => {
                this.maxPages = this.reservationService.maxPages;
                this.loadingStatus = false;
                if (res.length === 0) {
                    this.noResult = true;
                } else {
                    this.noResult = false;
                    this.setReservations(res);
                }
            });
        }
    }

    goPage(page): any {
        this.loadingStatus = true;
        this.currentPage = page;
        sessionStorage.setItem('ReservationFilterCurrentPage', this.currentPage.toString());
        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            this.currentPage, this.status, this.search, this.societySearch
        ).then((res) => {
            this.maxPages = this.reservationService.maxPages;
            this.loadingStatus = false;
            if (res.length === 0) {
                this.noResult = true;
            } else {
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.loadingStatus = true;
            this.currentPage -= 1;
            this.reservationService.updateReservationByDate(
                moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                this.currentPage, this.status, this.search, this.societySearch
            ).then((res) => {
                this.maxPages = this.reservationService.maxPages;
                this.loadingStatus = false;
                if (res.length === 0) {
                    this.noResult = true;
                } else {
                    this.noResult = false;
                    this.setReservations(res);
                }
            });
        }
    }

    goToCloture(): void {
        this.router.navigate(['carsharing/list']);
    }

    detaille(objet): void {
        console.log(objet);
    }

    exportDataAsXLSX(): any {
        let datas = [];
        let cols = this.excelService.initCols(["Code réservation", "Utilisateur", "Véhicule", "Date de début",
            "Date de fin", "Nombre d'heures reservées", "Date de début réelle", "Date de fin réelle", "Nombre d'heures réelle", "Distance parcourue", "Status", "Tarif"]);

        this.excelLoading = true;
        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then(async () => {
            this.maxPages = Math.max(this.reservationService.maxPages, 1);
            for (let i = 1; i <= this.maxPages; i++) {
                let results = await this.reservationService.updateReservationByDate(
                    moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                    moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                    i, this.status, this.search, this.societySearch
                );

                for (let result of results) {

                    let hours = Math.ceil(moment.duration(moment(result.ISODateEnd).diff(moment(result.ISODateStart))).asHours());
                    let realHours = Math.ceil(moment.duration(moment(result.ISORealDateEnd).diff(moment(result.ISORealDateStart))).asHours());

                    let field = await this.reservationService.getReservationInvoiceFields(result.Id)

                    let data = {}

                    if (field.length > 0) {
                        let tarification = 0

                        for (let f of field) {
                            tarification += (f.Quantity * f.IncludingTaxes)
                        }

                        data = {
                            "Code réservation": `${result.Code}`,
                            "Utilisateur": result.User,
                            "Véhicule": result.Vehicle,
                            "Date de début": (result.ISODateStart.length !== 0) ? moment(result.ISODateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Date de fin": (result.ISODateEnd.length !== 0) ? moment(result.ISODateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Nombre d'heures reservées": hours,
                            "Date de début réelle": (result.ISORealDateStart.length !== 0) ? moment(result.ISORealDateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Date de fin réelle": (result.ISORealDateEnd.length !== 0) ? moment(result.ISORealDateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Nombre d'heures réelle": (realHours) ? realHours : '',
                            "Distance parcourue": result.DistanceTraveled,
                            "Status": this.getStatus(result.Status),
                            "Montant TTC": tarification
                        };
                    }
                    else {
                        data = {
                            "Code réservation": `${result.Code}`,
                            "Utilisateur": result.User,
                            "Véhicule": result.Vehicle,
                            "Date de début": (result.ISODateStart.length !== 0) ? moment(result.ISODateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Date de fin": (result.ISODateEnd.length !== 0) ? moment(result.ISODateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Nombre d'heures reservées": hours,
                            "Date de début réelle": (result.ISORealDateStart.length !== 0) ? moment(result.ISORealDateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Date de fin réelle": (result.ISORealDateEnd.length !== 0) ? moment(result.ISORealDateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                            "Nombre d'heures réelle": (realHours) ? realHours : '',
                            "Distance parcourue": result.DistanceTraveled,
                            "Status": this.getStatus(result.Status),
                            "Montant TTC": 0
                        };
                    }

                    Object.values(data).forEach((value, index) => {
                        if (typeof value === 'string') {
                            cols[index].wch = Math.max(value.length, cols[index].wch);
                        }
                    });

                    datas.push(data);
                }
                // });
            }
            cols = this.excelService.extendCols(cols);
            this.excelService.exportExcel(datas, `vop-reservations_${moment(this.dateStart, 'DD-MM-YYYY').format().split('T')[0]}_${moment(this.dateEnd, 'DD-MM-YYYY').format().split('T')[0]}`, cols);
            this.excelLoading = false;
            this.alertService.alert("Données exportées avec succès");
        });
    }

    /* ------------------------------------------------------------------ */
    /*  New reservation modal                                              */
    /* ------------------------------------------------------------------ */

    openNewReservationModal() {
        this.newReservationError = '';
        if (this.session.role.ability === 'super-admin') {
            if (this.societies.length === 0) {
                this.societiesService.getSocieties().then((res) => {
                    this.societies = Array.isArray(res) ? res : [];
                });
            }
        } else {
            // Admin: pass session id_society_vop directly (SV-72)
            this.plannerIdSocietyVop = this.session.role.id;
        }
        this.showPlannerModal = true;
        setTimeout(() => {
            UIkit.modal('#modal-new-reservation').show();
        }, 0);
    }

    closeNewReservationModal() {
        UIkit.modal('#modal-new-reservation').hide();
        this.showPlannerModal = false;
        this.plannerSocietyCode = '';
        this.plannerIdSocietyVop = 0;
        this.clearPlannerUser();
        this.newReservationError = '';
    }

    onPlannerOperatorChange(value: string) {
        const id = parseInt(value, 10);
        this.plannerIdSocietyVop = isNaN(id) ? 0 : id;
        const society = this.societies.find(s => s.Id == id);
        this.plannerSocietyCode = society ? (society.Code || '') : '';
        this.clearPlannerUser();
    }

    onPlannerUserSearchInput(value: string) {
        this.plannerUserSearch = value;
        this.plannerSelectedUser = null;
        this.plannerIdAccountTarget = 0;
        this.plannerUserSearchChanged.next(value);
    }

    private searchPlannerUsers(q: string) {
        const query: any = { page: 1, pageSize: 20, search: q, column: 4, sortType: 1 };
        if (this.plannerSocietyCode) { query.codeSociety = this.plannerSocietyCode; }
        this.api.get('/MI_Galago/WCF_MI_Galago/REST/GetSocietyVopUsers', query, true).then((res: any) => {
            this.plannerUserOptions = Array.isArray(res) ? res : [];
            this.plannerShowUserOptions = this.plannerUserOptions.length > 0;
        });
    }

    selectPlannerUser(user: any) {
        this.plannerSelectedUser = user;
        this.plannerIdAccountTarget = user.AccountId || user.Id || 0;
        this.plannerUserSearch = `${user.FirstName} ${user.LastName} (${user.EMailAddress})`;
        this.plannerShowUserOptions = false;
        this.plannerUserOptions = [];
    }

    clearPlannerUser() {
        this.plannerSelectedUser = null;
        this.plannerIdAccountTarget = 0;
        this.plannerUserSearch = '';
        this.plannerUserOptions = [];
        this.plannerShowUserOptions = false;
    }

    onReservationCreated(payload: CreatedReservation) {
        this.reservationService.createReservation({
            idStation: payload.idStation,
            idVehicle: payload.idVehicle,
            begin: payload.begin,
            end: payload.end,
            comment: payload.comment || '',
            packIds: [],
            idAccountTarget: payload.idAccountTarget
        }).then((res: any) => {
            if (res && res.success === false) {
                this.planner?.notifyCreationError();
                this.newReservationError = res.message || 'Erreur lors de la création de la réservation.';
            } else {
                this.planner?.notifyCreationSuccess();
                this.closeNewReservationModal();
                this.alertService.alert('Réservation créée avec succès.');
                this.updateReservations();
            }
        }).catch(() => {
            this.planner?.notifyCreationError();
            this.newReservationError = 'Erreur lors de la création de la réservation.';
        });
    }

}